<template>
	<div v-on="$listeners" class="surf-inline-two-image-text-wrapper">
		<div class="surf-inline-two-image-text surf-hover-trigger">
			<div class="image">
				<el-image :src="formattedItem.image" fit="cover" class="image-content surf-transition-image-scale">
					<template #placeholder>
						<div class="image-placeholder"></div>
					</template>
					<template #error>
						<div class="image-error">
							<i class="el-icon-picture-outline error-icon"></i>
						</div>
					</template>
				</el-image>
			</div>
			<div class="content">
				<div class="value-section">
					<div class="value text-overflow">{{ formattedItem.value }}</div>
					<div class="sub-value">{{ normalizeYMDFormat(formattedItem.date) }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { normalizeYMDFormat } from '@/utils/format';

const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	},
	formatter: {
		type: Function,
		default: null
	}
});

const formattedItem = computed(() => {
	if (props.formatter && typeof props.formatter === 'function') {
		const formattedData = props.formatter(props.item);
		return { ...props.item, ...formattedData };
	}
	return props.item;
});
</script>

<style lang="less" scoped>
@import '@/style/global.less';

@image-text-box-border-radius: 8px;
@image-ratio: 51.64%;
@light-color: #fff;
@light-color-rgb: 255, 255, 255;
@dark-color-rgb: 29, 31, 32;
@border-color: rgba(0, 0, 0, 0.05);

.surf-inline-two-image-text-wrapper {
	position: relative;

	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		z-index: 3;
		width: 200%;
		height: 200%;
		border: 2px solid @border-color;
		border-radius: @image-text-box-border-radius * 2;
		transform: scale(0.5);
		transform-origin: 0 0;
		pointer-events: none;
	}
}
.surf-inline-two-image-text {
	position: relative;
	border-radius: @image-text-box-border-radius;
	cursor: pointer;
	overflow: hidden;

	.image {
		position: relative;
		padding-top: @image-ratio;
		width: 100%;
		overflow: hidden;

		.image-content {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			transition: transform 0.3s ease;
		}

		.image-placeholder {
			width: 100%;
			height: 100%;
			background-color: rgba(@light-color-rgb, 0.1);
		}

		.image-error {
			width: 100%;
			height: 100%;
			background-color: rgba(@light-color-rgb, 0.1);
			position: relative;

			.error-icon {
				position: absolute;
				top: 32%;
				left: 0;
				right: 0;
				margin: auto;
				text-align: center;
				font-size: 32px;
				color: rgba(@light-color-rgb, 0.3) !important;
			}
		}
	}

	.content {
		position: absolute !important;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 12px;
		background: linear-gradient(180deg, rgba(@dark-color-rgb, 0) 0%, rgba(@dark-color-rgb, 0.8) 100%);
		backdrop-filter: blur(50px);
		.thinner-border(1px solid rgba(@light-color-rgb, 0.3), none, none, none);

		.value-section {
			display: flex;
			flex-direction: column;
			gap: 12px;

			.value {
				color: @light-color;
				font-size: 16px;
				font-weight: 500;
				line-height: 24px;
			}

			.sub-value {
				color: rgba(@light-color-rgb, 0.7);
				font-size: 14px;
				font-weight: 400;
				line-height: 18px;
			}
		}
	}
}

.rs-d-surf-container {
	.image {
		padding-top: 56.15%;
	}
}

.mob-surf-layout {
	.surf-inline-two-image-text-wrapper {
		&::after {
			border-color: var(--surf-secondary-color);
		}
	}

	.surf-inline-two-image-text {
		.image {
			padding-top: 52.02%;
		}
		.content {
			padding: 8px;

			.value-section {
				gap: 4px;

				.value {
					font-size: 12px;
					font-weight: 500;
					line-height: 16px;

					height: 32px;
					// 换成两行
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: pre-wrap;
					word-break: break-all;
					display: -webkit-box;
					-webkit-line-clamp: 2 !important;
					/*! autoprefixer: off */
					-webkit-box-orient: vertical;
					/*! autoprefixer: off */
				}
				.sub-value {
					font-size: 8px;
					font-weight: 400;
					line-height: 12px;
				}
			}
		}
	}
}
</style>
